<template lang="pug">
  v-row(class="homepage-container")
    v-col(
      class="mt-md-5"
      xl="5"
      md="6"
      xs="12"
    )
      .app-heading
        .hidden-xs-only
          .text-h3.font-weight-bold.pb-2 Система
          .text-h3.font-weight-bold.pb-2 Дистанционного
          .text-h3.font-weight-bold.pb-2 Образования
        .hidden-sm-and-up
          .title.text-h4.strong СДО
          span Система дистанционного образования

      .title.mb-2.mt-4 Найди свой курс
      v-row
        v-col
          server-data(
            :method="$api.courses.getCourseList"
            no-init
            search-field-name="search[name]"
            v-slot="{ serverData, loading, search }"
          )
            course-list-filter-block(
              no-mounted-emit
              :loading="loading"
              @filters:update="routeToCourses($event)"
              @search="!!$event && search($event)"
            )
            v-slide-y-reverse-transition
              v-list.sdo-card.mt-2(v-if="!loading && serverData && serverData.length")
                v-list-item(
                  v-for="(item, idx) in serverData"
                  :key="idx"
                  :to="{ name: 'CourseView', params: { id: item.id } }"
                )
                  v-list-item-avatar
                    v-img(
                      :src="item.image_file_url || require('@/assets/course-sample.png')"
                    )
                  v-list-item-content
                    v-list-item-title {{ item.title }}
                    v-list-item-subtitle {{ item.type_activity.name }}
</template>

<script>
import CourseListFilterBlock from '@/modules/Courses/components/CourseListFilterBlock.vue';

export default {
  name: 'Homepage',
  components: {
    CourseListFilterBlock,
  },
  methods: {
    routeToCourses(query = {}) {
      this.$router.push({ name: 'CourseList', query });
    },
  },
};
</script>

<style lang="scss" scoped>
  .homepage-container {
    padding-top: 80px;
    margin-top: 100px;
  }

  h2 {
    font-weight: 500;
  }

  .v-btn:not(.v-btn--round).v-size--default {
    height: 40px;
  }

</style>

<style lang="scss">

  .app-heading {
    /*font-family: Avenir, Helvetica, Arial, sans-serif;*/
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .search fieldset {
    border: 1px solid #fff;
  }

  .v-autocomplete__content.v-menu__content {
    $border-radius: 6px;
    border-bottom-right-radius: $border-radius;
    border-bottom-left-radius: $border-radius;
  }

</style>
